// ADHD Questions

import type { Question } from '@/types/assessment';

export const asrsQuestions: Question[] = [
  // Part A - Screening Questions
  {
    id: 1,
    text: "How often do you have trouble wrapping up the final details of a project, once the challenging parts have been done?",
    part: 'A',
    category: 'inattention'
  },
  {
    id: 2,
    text: "How often do you have difficulty getting things in order when you have to do a task that requires organization?",
    part: 'A',
    category: 'inattention'
  },
  {
    id: 3,
    text: "How often do you have problems remembering appointments or obligations?",
    part: 'A',
    category: 'inattention'
  },
  {
    id: 4,
    text: "When you have a task that requires a lot of thought, how often do you avoid or delay getting started?",
    part: 'A',
    category: 'inattention'
  },
  {
    id: 5,
    text: "How often do you fidget or squirm with your hands or feet when you have to sit down for a long time?",
    part: 'A',
    category: 'hyperactivity'
  },
  {
    id: 6,
    text: "How often do you feel overly active and compelled to do things, like you were driven by a motor?",
    part: 'A',
    category: 'hyperactivity'
  },
  // Part B - Additional Questions
  {
    id: 7,
    text: "How often do you make careless mistakes when you have to work on a boring or difficult project?",
    part: 'B',
    category: 'inattention'
  },
  {
    id: 8,
    text: "How often do you have difficulty keeping your attention when you are doing boring or repetitive work?",
    part: 'B',
    category: 'inattention'
  },
  {
    id: 9,
    text: "How often do you have difficulty concentrating on what people say to you, even when they are speaking to you directly?",
    part: 'B',
    category: 'inattention'
  },
  {
    id: 10,
    text: "How often do you misplace or have difficulty finding things at home or at work?",
    part: 'B',
    category: 'inattention'
  },
  {
    id: 11,
    text: "How often are you distracted by activity or noise around you?",
    part: 'B',
    category: 'inattention'
  },
  {
    id: 12,
    text: "How often do you leave your seat in meetings or other situations where you are expected to remain seated?",
    part: 'B',
    category: 'hyperactivity'
  },
  {
    id: 13,
    text: "How often do you feel restless or fidgety?",
    part: 'B',
    category: 'hyperactivity'
  },
  {
    id: 14,
    text: "How often do you have difficulty unwinding and relaxing when you have time to yourself?",
    part: 'B',
    category: 'hyperactivity'
  },
  {
    id: 15,
    text: "How often do you find yourself talking too much when you are in social situations?",
    part: 'B',
    category: 'hyperactivity'
  },
  {
    id: 16,
    text: "When you're in a conversation, how often do you find yourself finishing the sentences of the people you are talking to, before they can finish them themselves?",
    part: 'B',
    category: 'hyperactivity'
  },
  {
    id: 17,
    text: "How often do you have difficulty waiting your turn in situations when turn taking is required?",
    part: 'B',
    category: 'hyperactivity'
  },
  {
    id: 18,
    text: "How often do you interrupt others when they are busy?",
    part: 'B',
    category: 'hyperactivity'
  }
];

export const responseOptions = [
  { value: 0, label: 'Never', color: 'bg-green-500' },
  { value: 1, label: 'Rarely', color: 'bg-yellow-500' },
  { value: 2, label: 'Sometimes', color: 'bg-orange-500' },
  { value: 3, label: 'Often', color: 'bg-red-500' },
  { value: 4, label: 'Very Often', color: 'bg-red-700' }
];